export default "__VITE_ASSET__DniTbU8t__"